<section class="sorteo-egresados-anahuac so3">
    <div class="container">
        <div class="row">

            <div class="col-lg-6 my-auto text-center d-lg-block d-none">
                <img src="/assets/images/magno/premeio-gan.png" class="img-fluid d-md-block d-none"
                    alt="Ganadores Sorteo Anáhuac Magno">
            </div>

            <div class="col-lg-6 my-auto text-center">
                <img src="/assets/images/magno/people-win.png" class="img-fluid " alt="Ganadores Sorteo Anáhuac Magno">

            </div>



        </div>
    </div>
</section>


<section class="stc-winners-opt so2">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 style="background-color:#ff5900 !important; padding: 15px;">
                    LISTA OFICIAL DE GANADORES
                    <span class="d-block">
                        SORTEO MAGNO 2025
                    </span>
                </h2>
            </div>
            <div class="col-md-12">
                <div class="text-center" style="overflow-x: auto;">
                    <label for="search" class="mt-5"
                        style="text-align: left !important; width: 100%; font-weight: 600; font-size: 18px;">Buscar:</label>
                    <input id="search" type="text" class="form-control mb-3" placeholder="Ingresa nombre o folio"
                        [(ngModel)]="searchText" (input)="filterData()" />
                    <table class="table table-striped">
                        <thead class="text-center">
                            <tr class="text-center">
                                <th class="border-none" colspan="4">Compradores</th>
                                <th class="border-none" colspan="3">Colaboradores</th>
                            </tr>
                            <tr class="text-center cols">
                                <th scope="col"><span>No. DE PREMIO</span></th>
                                <th scope="col"><span>Nombre</span></th>
                                <th scope="col"><span>Premio</span></th>
                                <th scope="col"><span>NÚMERO DE BOLETO</span></th>



                                <th scope="col"><span>Nombre</span></th>
                                <th scope="col"><span>Premio</span></th>

                                <th scope="col"><span>NÚMERO DE BOLETO</span></th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center"
                                *ngFor="let participante of filteredData | paginate: { itemsPerPage: 460, currentPage: p }">
                                <td>{{ participante.lugar }}</td>

                                <td>{{ participante.nombre_comprador + ' ' +
                                    getInitials(participante.apellidos_comprador) }}</td>

                                <td class="text-capitalize">{{ participante.premio_comprador }}</td>
                                <td>{{ participante.folio }}</td>

                                <td>{{ participante.nombre_col + ' ' + getInitials(participante.apellidos_col) }}</td>
                                <td>{{ participante.premio_col }}</td>
                                <td>Por vender el boleto {{ participante.folio }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination-controls (pageChange)="p = $event" previousLabel="Anterior" nextLabel="Siguiente">
                    </pagination-controls>
                </div>
            </div>


            <!-- Repite lo mismo para las otras dos tablas -->



            <div class="col-12 mt-5 pt-0 footer-egr">
                <p>
                    <strong>
                        SORTEO ANÁHUAC MAGNO
                    </strong>
                </p>


                <p>
                    El Sorteo Anáhuac celebró el día jueves 20 de noviembre de 2025, a las 17:00 horas, el SORTEO
                    ANÁHUAC MAGNO, en las Instalaciones de la Universidad Anáhuac Cancún con domicilio en Boulevard Luis
                    Donaldo Colosio no. Km 13.5 M 2 Colonia Zona 8 Sm 299, Carretera Cancún-Tulum, C.P. 77565, Cancún
                    Benito Juárez, Quintana Roo.; con la presencia del C. <strong>Oliver González Aguilar</strong>,
                    Inspector asignado por la Dirección General de Juegos y Sorteos, para dar fe y legalidad del evento.
                </p>

                <p>
                    De acuerdo con lo establecido en el Permiso No. 20250046PS07 otorgado por la Secretaría de
                    Gobernación a Sorteo Anáhuac, A.C., los resultados de los ganadores directos, así como los nombres
                    de los colaboradores que se han hecho acreedores a un premio por haber vendido los boletos de los
                    premios del 1 (uno) al 460 (cuatrocientos sesenta) , han de ser publicados de forma posterior al
                    evento del sorteo en la página de internet https://www.sorteoanahuac.mx/ y nuestras redes sociales a
                    partir del día 22 noviembre de 2025 y de acuerdo a lo registrado ante SEGOB, solo aparecerá el
                    nombre propio de los ganadores, completándose con las iniciales de cada uno de los apellidos,
                    adicionalmente, se publicará la lista con los nombres completos de los ganadores en las
                    Instalaciones de la Universidad Anáhuac México Campus Norte, ubicada en la Av. Universidad no. 46
                    Colonia Lomas de Anáhuac, CP. 52786, Huixquilucan Estado de México.
                </p>

                <p>
                    Venta directa desde www.sorteoanahuac.mx /Colaborador Institucional responsable: Pablo Galindo Vega.
                    Los boletos vendidos directamente desde la página web no cuentan con un colaborador individual
                    sujeto a beneficios en premios, sino a un colaborador institucional responsable cuyo nombre aparece
                    en el listado. Los premios para colaborador, en estos casos, son dados automáticamente al programa
                    de becas de la Red de Universidades Anáhuac.
                    Los premios mayores a 1,500 (UMA), $169,710.00 (Ciento sesenta y nueve mil setecientos diez pesos
                    00/100 m.n.) se solicitará la presencia de un inspector de la DGJS para la entrega de los mismos,
                    conforme al siguiente calendario de fechas:

                </p>

                <div>
                    <table>
                        <thead>
                            <tr>
                                <th><strong>FECHA DEL EVENTO</strong></th>
                                <th><strong>HORA DEL EVENTO</strong></th>
                                <th><strong>LUGAR DEL EVENTO</strong></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td scope="row">08 DE DICIEMBRE DE 2025</td>
                                <td>11:00 horas</td>
                                <td>
                                    ENTREGA DE LOS PREMIOS 6° AL 20° DIRECTOS Y DEL 1° AL 4° DE COLABORADOR, EN LAS
                                    INSTALACIONES
                                    DE LA UNIVERSIDAD ANÁHUAC MÉXICO CAMPUS NORTE CON DOMICILIO EN AVENIDA UNIVERSIDAD
                                    ANAHUAC
                                    NO. 46 COL. LOMAS DE ANÁHUAC C.P.52786 EN HUIXQUILUCAN, ESTADO DE MÉXICO, MÉXICO
                                </td>
                            </tr>

                            <tr>
                                <td scope="row">09 DE DICIEMBRE DE 2025</td>
                                <td>11:00 horas</td>
                                <td>
                                    ENTREGA DEL PREMIO 2: Boulevard Bosque Real Lote 16-A Manzana 5 Conjunto
                                    Habitacional
                                    Bosque
                                    Real Five Torre B Dpto. 2702 CP. 52774 Huixquilucan, Estado de México
                                </td>

                            </tr>
                            <tr>
                                <td scope="row">
                                    10 DE DICIEMBRE DE 2025
                                </td>

                                <td>11:00 horas</td>
                                <td>
                                    ENTREGA DEL PREMIO 3: Condominio El Origen, Localidad Komchen Lote 16 C.P. 97302
                                    Manzana 0000 Mérida, Yucatán. México
                                </td>

                            </tr>


                            <tr>
                                <td scope="row">
                                    11 DE DICIEMBRE
                                    DE 2025
                                </td>

                                <td>11:00 horas</td>
                                <td>
                                    ENTREGA DEL PREMIO 1: Residencial Brezza, Avenida Antonio Enrique Savignac, lote
                                    4C-4
                                    manzana 1 SM 4A Cancún, Municipio de Benito Juarez, Quintana Roo. México.
                                </td>

                            </tr>


                            <tr>
                                <td scope="row">
                                    15 DE DICIEMBRE
                                    DE 2025
                                </td>

                                <td>11:00 horas</td>
                                <td>
                                    ENTREGA DEL PREMIO 5: Boulevard de los Volcanes Sur 1302 Calle 4 Lote 34 Conjunto
                                    Habitacional
                                    El Capricho y/o Parque el Capricho Cascatta II Col. Lomas de Angelópolis CP.72865
                                    Municipio de
                                    Ocoyucan Puebla. México.
                                </td>

                            </tr>

                            <tr>
                                <td scope="row">
                                    16 DE DICIEMBRE
                                    DE 2025
                                </td>

                                <td>11:00 horas</td>
                                <td>
                                    ENTREGA DEL PREMIO 4: Casa Condominio Calle Avenida Cayuco Condominio C número 12-C
                                    Interior
                                    C57 Lote 202 Manzana XXI Fracc. Zibatá II Municipio El Marqués Querétaro. CP. 76269
                                    Querétaro., México.
                                </td>

                            </tr>



                        </tbody>
                    </table>

                    <p>
                        Para recibir sus premios, los ganadores deberán mostrar en caso de tener un boleto físico, la
                        parte del contra talón (boleto original) con el número ganador e identificación oficial vigente
                        con fotografía. Para el caso de los boletos digitales, el ganador solamente deberá mostrar por
                        medio de su aparato móvil la imagen del boleto digital con el número ganador que le llegó vía
                        correo electrónico al hacer la compra de su boleto y su identificación oficial vigente con
                        fotografía.
                    </p>

                    <p>
                        Los premios serán pagados y entregados de conformidad con lo establecido en las bases de Sorteo.
                        Los premios menores a 1,500 (UMA) , 169,710.00 (Ciento sesenta y nueve mil setecientos diez
                        pesos 00/100 m.n.) se realizará dentro de los 20 (veinte) días hábiles contados a partir de la
                        celebración del sorteo, en Avenida Universidad Anáhuac N° 46, Col. Lomas Anáhuac, C.P. 52786,
                        Huixquilucan, Estado de México, piso 7 del edificio de Biblioteca, en horario de lunes a jueves
                        de 10:00 a 18:00 hrs. y los viernes de 10:00 a 14:00 hrs. Para más información sobre dónde
                        reclamar la entrega de los premios, documentos necesarios para recibirlos diríjase a:
                        www.sorteoanahuac.mx, o a la oficina del Sorteo Anáhuac, A.C. ubicada en la calle Av.
                        Universidad Anáhuac no. 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de México o al
                        teléfono: 01(55) 5328-8096 ext 7474.
                    </p>

                    <p>
                        Las personas que resulten ganadoras deberán presentar una identificación oficial vigente con
                        fotografía (credencial INE, pasaporte), comprobante de domicilio (no mayor a tres meses),
                        Constancia de situación fiscal (mes en curso) y CURP; el nombre completo escrito en el boleto
                        debe corresponder exactamente con el del talón o con el registro en la APP del Sorteo Anáhuac y
                        su identificación oficial.
                        En caso de queja derivada de este sorteo, la autoridad competente es la Dirección General de
                        Juegos y Sorteos de la Secretaría de Gobernación ubicada en la calle de Versalles 49, piso 2,
                        Col. Juárez, Del. Cuauhtémoc, C.P. 06600, Ciudad de México o bien comunicarse al teléfono:
                        01(55) 5209 8800.
                    </p>

                </div>



                <p>
                    <strong>
                        PERMISO SEGOB: 20250046PS07
                    </strong>
                </p>
            </div>


        </div>
    </div>
</section>